/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let unsubscribedUserListApiUrl = root.unsubscribedUserListApiUrl.link;
import Vue from 'vue'
export default {
  state: {
    getUnsubscribedUserListState:{}
    },
  mutations: {
    getUnsubscribedUserListMutation(state, value) {
      Vue.set(state, 'getUnsubscribedUserListState', value);
    },
  },
  actions: {
    // Get Unsubscribed User All List
    geUnsubscribedUserListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(unsubscribedUserListApiUrl).then(res => {
              context.commit('getUnsubscribedUserListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getUnsubscribedUserListGetters: state => state.getUnsubscribedUserListState
  }
}